export const MODULES = {
  DISPATCH: "dispatch",
  BACKTRACK: "backtrack",
  DISPATCHER_MODE: "dispatcher mode",
  BUSINESS_TRIP: "business trip",
  FLIGHT_TRACKING: "flight tracking",
};

export const extractModuleNames = (company) => {
  const modules = company?.active_subscription?.plan?.modules;
  if (!Array.isArray(modules)) return [];
  return modules
    .map((m) => (m?.name || "").toLowerCase().trim())
    .filter(Boolean);
};

export const hasModuleAccess = (modules, moduleName) =>
  Array.isArray(modules) && modules.includes(String(moduleName).toLowerCase());
